import { render, staticRenderFns } from "./my-gig-extension.page.vue?vue&type=template&id=27424f58&scoped=true&"
import script from "./my-gig-extension.page.vue?vue&type=script&lang=js&"
export * from "./my-gig-extension.page.vue?vue&type=script&lang=js&"
import style0 from "./my-gig-extension.page.vue?vue&type=style&index=0&id=27424f58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27424f58",
  null
  
)

export default component.exports